import React, { useState } from "react";
import propTypes from "prop-types";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableFooter,
  TablePagination,
  TableRow,
  Paper
} from "@material-ui/core";
import uuid from "uuid/v4";

import TableActions from "../TableActions/TableActions";
import useStyles from "./stylesRecolecciones";

const columns = [
  { id: "paqueteria", label: "Paquetería", minWidth: 100 },
  { id: "fecha", label: "Fecha", minWidth: 100 },
  { id: "desde", label: "Hora inicial", minWidth: 100 },
  { id: "hasta", label: "Hora final", minWidth: 100 },
  { id: "folio", label: "Folio", minWidth: 100 }
];

const TableRecolecciones = ({ data = [] }) => {
  const classes = useStyles();
  const rows = data;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const handleChangePage = (e, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = e => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  return (
    <Paper className={classes.tablePaper}>
      <div className={classes.tableWrapper}>
        <Table className={classes.table} aria-label="Tabla Recolecciones" stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell key={column.id}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(row => (
                <TableRow key={uuid()}>
                  <TableCell align="left">{row.paqueteria}</TableCell>
                  <TableCell align="left">{row.fecha}</TableCell>
                  <TableCell align="left">{row.desde}</TableCell>
                  <TableCell align="left">{row.hasta}</TableCell>
                  <TableCell align="left">{row.folio}</TableCell>
                </TableRow>
              ))}

            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                colSpan={7}
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { "aria-label": "Renglones por página" },
                  native: true
                }}
                labelRowsPerPage="Renglones por página"
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                ActionsComponent={TableActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </div>
    </Paper>
  );
};

TableRecolecciones.propTypes = {
  data: propTypes.array
};

export default TableRecolecciones;
